import React, { useEffect, useState } from "react";
import styles from "./navMenuItem.module.scss";
import { Box } from "@mui/system";
import i18next from "i18next";
import { NavLink, useLocation } from "react-router-dom";
import NavDropdown from "../navDropDownComponent/NavDropdown";
import { useNavbarContext } from "../../NavbarCotext";
import _ from "lodash";
import PropTypes from "prop-types";

// button without dropdown
const MenuItemWithOutDropdown = (props) => {
  const { iconStyle, name, link, onNavClick } = props;
  return (
    <NavLink
      to={link}
      className={`${styles.navLink}`}
      style={({ isActive }) => ({
        backgroundColor: isActive ? "#0265C7" : "",
        borderBottom: isActive ? "5px solid #003A74" : "",
        height: "72px",
      })}
      data-testid="menu-without-dropdown"
      onClick={() => onNavClick()}
    >
      <Box className={styles.navMenuItemWrapper}>
        <Box className={`${iconStyle} ${styles["iconWrapper"]}`}></Box>
        <Box className={styles.textWrapper}>{i18next.t(name)}</Box>
      </Box>
    </NavLink>
  );
};

// button with dropdown
const MenuItemWithDropdown = (props) => {
  const { iconStyle, name, menu_list } = props;
  const [isActive, setIsActive] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const { navState } = useNavbarContext();
  const location = useLocation();
  const menuSubLinks = menu_list.map((menu) => menu.link);

  useEffect(() => {
    if (
      name === navState.selectedNavItem ||
      _.includes(menuSubLinks, location?.pathname) || isPopupOpen
    ) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [navState.selectedNavItem, name, menuSubLinks, location?.pathname,isPopupOpen]);
  const setIsActivefn = (isPopupOpen) => {
    
    setIsPopupOpen(isPopupOpen);
  };
  return (
    <Box
      className={`${styles.navLink}`}
      sx={{
        backgroundColor: isActive ? "#0265C7" : "",
        borderBottom: isActive ? "5px solid #003A74" : "",
        height: "72px",
      }}
      data-testid="menu-with-dropdown"
    >
      <NavDropdown
        menuname={name}
        link_name={name}
        icon_style={iconStyle}
        iconClass={styles.serviceIcon}
        textClass={styles.menuText}
        menu_list={menu_list}
        setIsActivefn={value => setIsActivefn(value)}
      />
    </Box>
  );
};

const NavMenuItem = (props) => {
  return props.isDropDown ? (
    <MenuItemWithDropdown {...props} />
  ) : (
    <MenuItemWithOutDropdown {...props} />
  );
};
export default NavMenuItem;
NavMenuItem.propTypes = {
  isDropDown : PropTypes.any,
};

MenuItemWithDropdown.propTypes = {
  iconStyle :PropTypes.any, 
  name:PropTypes.any, 
  menu_list:PropTypes.any
};

MenuItemWithOutDropdown.propTypes = {
  iconStyle :PropTypes.any,  
  name :PropTypes.any,  
  link :PropTypes.any, 
  onNavClick  :PropTypes.any, 
};
